//
//  DocumentationLegacyPageBlockTable.ts
//  Pulsar Language
//
//  Created by Jiri Trecak.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Imports
import { DocumentationLegacyPageBlock, } from "../SDKDocumentationLegacyPageBlock";
import { DocumentationLegacyPageBlockTableColumn, } from "./SDKDocumentationLegacyPageBlockTableColumn";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class DocumentationLegacyPageBlockTable extends DocumentationLegacyPageBlock {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model, children) {
        super(model, children);
        this.tableProperties = {
            showBorders: model.tableProperties.showBorders,
            showHeaderRow: model.tableProperties.showHeaderRow,
            showHeaderColumn: model.tableProperties.showHeaderColumn,
            columns: model.tableProperties.columns.map((c) => new DocumentationLegacyPageBlockTableColumn(c)),
        };
        const order = new Map();
        let index = 0;
        for (const column of this.tableProperties.columns) {
            order.set(column.id, index);
            index += 1;
        }
        // @ts-expect-error TS(2532): Object is possibly 'undefined'.
        for (const block of this.children) {
            const row = block;
            // @ts-expect-error TS(2532): Object is possibly 'undefined'.
            row.children = row.children.sort(
            // @ts-expect-error TS(2345): Argument of type '(a: DocumentationLegacyPageBlock... Remove this comment to see the full error message
            (a, b
            // @ts-expect-error TS(2532): Object is possibly 'undefined'.
            ) => order.get(a.columnId) - order.get(b.columnId));
        }
    }
}
